var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicBackupRecoveryPhonemin = function SvgGraphicBackupRecoveryPhonemin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 182,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.087 56.68c-.144 0-.287.007-.43.01v-.01c0-12.526-10.299-22.68-23.004-22.68-10.317 0-19.047 6.696-21.965 15.92a15.95 15.95 0 0 0-7.37-1.794c-8.75 0-15.844 6.994-15.844 15.621 0 1.405.19 2.766.544 4.062a12.917 12.917 0 0 0-5.196-1.091C37.74 66.718 32 72.378 32 79.359S37.74 92 44.822 92h73.265C127.98 92 136 84.093 136 74.34c0-9.754-8.02-17.66-17.913-17.66Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.026 46H95.974C92.122 46 89 48.914 89 52.508v82.984c0 3.594 3.123 6.508 6.974 6.508h54.052c3.851 0 6.974-2.914 6.974-6.508V52.509c0-3.595-3.123-6.509-6.974-6.509Z",
    fill: "#0090ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.667 54h-43.334C99.493 54 98 55.477 98 57.299v73.402c0 1.822 1.492 3.299 3.333 3.299h43.334c1.841 0 3.333-1.477 3.333-3.299V57.299c0-1.822-1.492-3.299-3.333-3.299Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.333 46h-14.666c-1.473 0-2.667 1.475-2.667 3.294v7.412c0 1.82 1.194 3.294 2.667 3.294h14.666c1.473 0 2.667-1.475 2.667-3.294v-7.412c0-1.82-1.194-3.294-2.667-3.294Z",
    fill: "#0090ED"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animate-grow-and-stay",
    style: {
      transformOrigin: "8rem 6rem"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 75H65c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h55c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Z",
    fill: "#1CC4A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.632 84.632 98 97.264l12.632 12.632 12.632-12.632-12.632-12.632Z",
    fill: "#1CC4A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "animate-fade-out-in opacity-20 animation-delay-1200",
    d: "m73.385 91.804.704 3.051h-2.994l.704-3.051-2.34 2.126L68 91.328l2.994-.9-2.994-.95 1.535-2.552 2.264 2.126L71.095 86h2.994l-.73 3.102 2.366-2.176 1.484 2.601-3.095.926 3.095.925-1.535 2.552-2.29-2.126Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "animate-fade-out-in opacity-20 animation-delay-1000",
    d: "m99.803 91.804.704 3.051h-2.994l.704-3.051-2.34 2.126-1.459-2.602 2.994-.9-2.994-.95 1.535-2.552 2.264 2.126L97.513 86h2.994l-.73 3.102 2.366-2.176 1.484 2.601-3.095.926 3.095.925-1.535 2.552-2.29-2.126Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "animate-fade-out-in opacity-20 animation-delay-1500",
    d: "m86.594 91.804.704 3.051h-2.994l.704-3.051-2.34 2.126-1.459-2.602 2.994-.9-2.994-.95 1.535-2.552 2.264 2.126L84.304 86h2.994l-.73 3.102 2.366-2.176 1.484 2.601-3.095.926 3.095.925-1.535 2.552-2.29-2.126Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "animate-fade-out-in opacity-20 animation-delay-1200",
    d: "m113.013 91.804.704 3.051h-2.994l.704-3.051-2.34 2.126-1.459-2.602 2.994-.9-2.994-.95 1.535-2.552 2.264 2.126-.704-3.052h2.994l-.73 3.102 2.366-2.176 1.484 2.601-3.095.926 3.095.925-1.535 2.552-2.289-2.126Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animate-pulse-twinkle-first",
    style: {
      transformOrigin: "10.5rem 4rem"
    },
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.55 63.944a.46.46 0 0 0-.376-.466c-.918-.166-3.455-.765-4.321-1.618-.866-.853-1.452-3.39-1.613-4.322a.46.46 0 0 0-.463-.375v6.781h6.773Z",
    fill: "#DABDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.807 57.162a.464.464 0 0 0-.458.39c-.155.913-.725 3.409-1.583 4.332-.858.924-3.409 1.46-4.387 1.635a.468.468 0 0 0-.379.466h6.812l-.005-6.823Z",
    fill: "#00B3F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.771 63.944v6.782a.489.489 0 0 0 .463-.39c.167-.928.766-3.503 1.619-4.359.853-.855 3.392-1.42 4.31-1.575a.461.461 0 0 0 .387-.452l-6.779-.006Z",
    fill: "#00B3F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163 63.944a.444.444 0 0 0 .39.456c.926.158 3.509.724 4.376 1.583.866.858 1.428 3.406 1.583 4.376a.467.467 0 0 0 .458.4v-6.812L163 63.944Z",
    fill: "#007BED"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animate-pulse-twinkle-second",
    style: {
      transformOrigin: "11.5rem 3.2rem"
    },
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.918 53.88a.811.811 0 0 0-.647-.807c-1.586-.3-5.964-1.318-7.46-2.79-1.495-1.47-2.506-5.849-2.792-7.459a.792.792 0 0 0-.804-.647V53.88h11.703Z",
    fill: "#DABDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.279 42.177a.795.795 0 0 0-.786.671c-.271 1.577-1.252 5.883-2.735 7.478-1.484 1.594-5.871 2.518-7.568 2.804a.805.805 0 0 0-.656.806h11.735l.01-11.759Z",
    fill: "#00B3F4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.215 53.88v11.702a.841.841 0 0 0 .798-.671c.286-1.604 1.321-6.046 2.792-7.523 1.472-1.477 5.853-2.45 7.442-2.708a.797.797 0 0 0 .665-.782l-11.697-.019Z",
    fill: "#00B3F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M175.534 53.88a.777.777 0 0 0 .674.788c1.595.27 6.054 1.245 7.55 2.729 1.495 1.483 2.464 5.877 2.735 7.553a.798.798 0 0 0 .786.689v-11.76h-11.745Z",
    fill: "#007BED"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "animate-pulse-twinkle-third",
    style: {
      transformOrigin: "11rem 2.5rem"
    },
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.649 41.466a.31.31 0 0 0-.245-.308c-.608-.109-2.278-.501-2.848-1.065-.569-.564-.956-2.232-1.068-2.848a.301.301 0 0 0-.302-.245v4.466h4.463Z",
    fill: "#DABDFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.207 37.003a.306.306 0 0 0-.302.256c-.101.602-.477 2.245-1.041 2.853-.564.607-2.245.961-2.891 1.073a.303.303 0 0 0-.18.107.305.305 0 0 0-.07.198h4.484v-4.487Z",
    fill: "#00B3F4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M173.186 41.466v4.468a.32.32 0 0 0 .302-.256c.112-.613.504-2.307 1.068-2.877.564-.57 2.235-.934 2.84-1.035a.302.302 0 0 0 .253-.3h-4.463Z",
    fill: "#00B3F4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M168.723 41.466a.296.296 0 0 0 .258.302c.608.101 2.311.474 2.883 1.041.572.567.94 2.245 1.041 2.883a.309.309 0 0 0 .303.273v-4.5h-4.485Z",
    fill: "#007BED"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.191 120.333c.13 0 .259.007.388.01v-.01c0-11.229 9.309-20.333 20.792-20.333 9.325 0 17.216 6.003 19.853 14.273a14.511 14.511 0 0 1 6.662-1.608c7.909 0 14.321 6.27 14.321 14.005 0 1.26-.173 2.48-.492 3.641a11.755 11.755 0 0 1 4.696-.978c6.4 0 11.589 5.074 11.589 11.334 0 6.259-5.189 11.333-11.589 11.333h-66.22c-8.942 0-16.191-7.089-16.191-15.833 0-8.745 7.249-15.834 16.191-15.834Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 168,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_12110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_12110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 91,
    y: 66,
    width: 158,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_12110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_12110",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicBackupRecoveryPhonemin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_backup_recovery_phone.min.4667c26801ee2094be03c7cf21265e81.svg";